import { render, staticRenderFns } from "./Programa-ins2.vue?vue&type=template&id=732e63a4"
import script from "./Programa-ins2.vue?vue&type=script&lang=js"
export * from "./Programa-ins2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports